import React, { FC } from 'react';
import classNames from 'classnames';

import styles from './ModifierCommandPaletteChip.module.scss';

interface ModifierCommandPaletteChipProps {
 label: string | undefined;
 kind: string | undefined;
 className?: string;
}

const ModifierCommandPaletteChip: FC<ModifierCommandPaletteChipProps> = ({
  label,
  className,
  kind,
}) => {
  const subtractive = !!kind && ['no', 'remove', 'sub'].includes(kind);
  return (
    <div className={classNames(className, styles.root, {
      [styles.plus]: !subtractive,
      [styles.minus]: subtractive,
    })}>
      {label}
    </div>
  );
};

export { ModifierCommandPaletteChip };
export type { ModifierCommandPaletteChipProps };
